module.exports = __webpack_public_path__ + "static/media/dark.8425ce16.svg";